<template>
    <div id="ContainerLetter">
        <div class="row page-height">
            <div class="col-12">
                <MdTitleRegInfo
                    v-bind:RegistrationInfo="PatientTitle" 
                    v-bind:titlePrefix="this.Mode ? $t('PatientLetters.EditLetter'): $t('PatientLetters.AddLetter')" 
                    v-bind:IsClinical="IsClinical"
                    v-bind:titleRef="'titleElementPatientLetter'"
                    v-bind:patientCode="this.$route.params.id">
                </MdTitleRegInfo>

                <div class="alert alert-fill-warning d-flex align-items-center m-3" role="alert" v-if="isReadOnly">
                    <i class="mdi mdi-alert-circle me-2" style="font-size: 1.5rem;"></i>
                    <div class="flex-grow-1">
                        <span>{{ $t('Shared.ReadOnlyPermission') }}</span>
                    </div>
                </div>
            </div>
        </div>

        <div class="row"> 
            <b-col md="10" lg="10" sm="12">
                <MdSelect
                    v-bind:Label="$t('PatientLetters.Template')"
                    v-bind:Options="LetterTemplateList"
                    v-bind:FieldDescription="'name'"
                    v-bind:FieldCode="'code'"
                    v-bind:Model="letterTemplateModel" 	
                    v-bind:isRequired="true" 
                    v-bind:isValid="isLetterTemplateValid"
                    v-bind:Multiple="false"
                    :Input="changeDropDownLetterTemplate"
                    id="letter_template_select"       
                    :IsDisabled="isReadOnly || Mode"             
                />
            </b-col> 
            <b-col md="2" lg="2" sm="12">
                <MdButton
                    v-bind:Label="$t('PatientLetters.Generate')"
                    v-bind:ClassProp="'btn btn-primary my-3 btn-block btn-login'"
                    v-on:click="generateLetter"
                    v-bind:isReadOnly="this.isReadOnly || !generateButtonEnable"
                    v-bind:Name="'btn_generate_letter'"/>
            </b-col>
        </div>

        <div class="row" v-if="isSignedByEmployee || isSignedByPatient">
            <b-col lg="3" md="3" sm="12" v-if="isSignedByEmployee">            
                <MdCheckBox
                    v-bind:Label="$tc('PatientLetters.EmployeeSigned')"
                    v-bind:Name="'checkbox-employeesigned'"
                    v-bind:ClassProp="'AlignCheck'"
                    v-bind:CheckedValue="true"
                    v-bind:UncheckedValue="false"
                    v-model="editableItem.employeesigned"
                    v-bind:isReadOnly="isReadOnly"
                    v-on:change="onChangeEmployeeSigned"/>
            </b-col>
            <b-col md="3" lg="3" sm="12" v-if="isSignedByEmployee">
                <MdEdit 
                    v-bind:Label="$t('Shared.Date')"
                    v-bind:TypeProp="'date'" 
                    v-bind:Name="'date'"
                    v-bind:Min="'1900-01-01'"
                    v-bind:Max="'2200-12-31'"
                    v-model="editableItem.therapistsigneddate"
                    v-bind:isReadOnly="isReadOnly || !editableItem.employeesigned"
                    v-bind:isRequired="editableItem.employeesigned"
                    v-bind:isValid="isEmployeeSignedDateValid">                                     
                </MdEdit>
            </b-col>
            <b-col lg="3" md="3" sm="12" v-if="isSignedByPatient">            
                <MdCheckBox
                    v-bind:Label="$tc('PatientLetters.PatientSigned')"
                    v-bind:Name="'checkbox-patientsigned'"
                    v-bind:ClassProp="'AlignCheck'"
                    v-bind:CheckedValue="true"
                    v-bind:UncheckedValue="false"
                    v-model="editableItem.patientsigned"
                    v-bind:isReadOnly="isReadOnly"
                    v-on:change="onChangePatientSigned"/>
            </b-col>
            <b-col md="3" lg="3" sm="12" v-if="isSignedByPatient">
                <MdEdit 
                    v-bind:Label="$t('Shared.Date')"
                    v-bind:TypeProp="'date'" 
                    v-bind:Name="'date'"
                    v-bind:Min="'1900-01-01'"
                    v-bind:Max="'2200-12-31'"
                    v-model="editableItem.patientsigneddate"
                    v-bind:isReadOnly="isReadOnly || !editableItem.patientsigned"
                    v-bind:isRequired="editableItem.patientsigned"
                    v-bind:isValid="isPatientSignedDateValid">                                     
                </MdEdit>
            </b-col>
        </div>

        <b-row v-if="filters.length !== 0">
            <b-col md="3" lg="3" sm="12" v-for="(filter,index) in filters" :key="index">
                <MdEdit v-if="filter.controlType == 'ctDate'"
                    v-bind:Label="filter.caption"
                    v-bind:TypeProp="'date'" 
                    v-model="filter.controlValue"
                    v-bind:Name="`ctDate_${index}`"
                    v-bind:Id="`ctDate_${index}`"
                    v-bind:Min="'1900-01-01'"
                    v-bind:Max="'2200-12-31'"
                    v-bind:isValid="filter.isValid"
                    :ref="`ctDate_${index}`"
                    v-bind:isRequired="true"
                    :OnPressEnter="onDatePressEnter"
                >                                     
                </MdEdit>
                <MdEdit v-if="filter.controlType == 'ctNumber'"
                    v-bind:Label="filter.caption"
                    v-bind:TypeProp="'number'" 
                    v-model="filter.controlValue"
                    v-bind:Name="`ctDate_${index}`"
                    v-bind:Id="`ctDate_${index}`"
                >
                </MdEdit>
                <MdEdit v-if="filter.controlType == 'ctEdit'"
                    v-bind:Label="filter.caption"
                    v-bind:TypeProp="'text'"
                    v-model="filter.controlValue"
                    v-bind:Name="`ctDate_${index}`"
                    v-bind:Id="`ctDate_${index}`"
                >                                     
                </MdEdit>
                <MdCheckBox v-if="filter.controlType == 'ctCheckBox'"
                    v-bind:Label="filter.caption"
                    v-bind:CheckedValue="'Y'"
                    v-bind:UncheckedValue="'N'"
                    v-model="filter.controlValue"
                    v-bind:Name="`ctDate_${index}`"
                >
                </MdCheckBox>
                <MdSelect v-if="filter.controlType == 'ctCombo'"
                    v-bind:Label="filter.caption"
                    v-bind:Options="filter.itemList"
                    v-bind:FieldDescription="'value'"
                    v-bind:FieldCode="'key'"
                    v-bind:Multiple="false"
                    v-bind:Model="filter.controlValue"
                    v-bind:UseParamsAux="true"
                    v-bind:AuxParam="filter"
                    :Input="changeDropDown"
                    v-bind:Name="`ctCombo_${index}`"
                    v-bind:Id="`ctCombo_${index}`"
                >
                </MdSelect>
                <MdEdit v-if="filter.controlType == 'ctMemo'"
                    v-bind:Label="filter.caption"
                    v-bind:TypeProp="'text'"
                    v-model="filter.controlValue"
                    v-bind:Name="`ctMemo_${index}`"
                    v-bind:Id="`ctMemo_${index}`"
                >                                     
                </MdEdit>
                <MdRadioGroup v-if="filter.controlType == 'ctRadio'"
                    v-bind:Label="filter.caption"
                    v-model="filter.controlValue"
                    v-bind:Options="filter.itemList"
                >
                </MdRadioGroup>
            </b-col>
        </b-row>

        <div class="row mt-3" v-if="generated">
            <b-col md="12" lg="12" sm="12">
                <MdRichEdit
                    ref="myEditor" 
                    v-model="letterContents"
                    v-bind:isReadOnly="isReadOnly"
                    v-bind:Height="'400px'"
                    v-bind:id="'edit_letterContent'"
                    v-bind:isRequired="false"
                    v-bind:HideToolBar="false"
                    v-bind:StartupFocus="false"
                />
            </b-col>
        </div>

        <div class="space-actions"></div>
        <div class="page-actions">
            <MdButton
                v-bind:Label="$t('Shared.Back')"
                v-bind:Name="'btnLettersList'"
                v-bind:ClassProp="'secondary mx-2 btn-login'"
                v-on:click="DiscardChanges"/>
            
            <MdButton
                v-bind:Label="$t('Shared.Save')"
                v-bind:ClassProp="(this.isReadOnly)?'primary mx-2':'primary btn-login mx-2'"
                v-on:click="ClickSaveCall"
                v-bind:isReadOnly="!saveButtonEnable"
                v-bind:Name="'btn_save_letter'"/>
        </div>
    </div>
</template>

<script>
import EnumService from '@/services/enum.service'
import Utils from '@/common/utils'
import LocalStorage from '@/services/storage.service'
import GlobalService from '@/services/global.service'
import ShowMessage from '@/components/messages/ShowMessage.js'
import DBFunctions from '@/common/DBFunctions.js'
import { EventBus } from '@/event-bus.js';
import LetterTemplatesService from '@/services/lettertemplates.service'
import NoteTemplatesService from '@/services/notetemplates.service'

export default {
    name: 'LetterManagement',
    mixins: [ShowMessage, DBFunctions,],

    data() {
        return {
            isReadOnly: false,
            Mode:this.$attrs.editMode,
            RegistrationInfo:{},
            IsClinical:false,
            UserId:LocalStorage.getUserId(),
            OptionsRightMenu:{
                visible:true,
                ItemsList:[],
                btnvisible:true,
                itemdisabled: false,
                PatientCode:''         
            },
            PatientTitle:{      
                programName:'',
                fullName:'',
                admitDate:'',
                dischargeDate:'',
                dob:'',
                activitytypename:'',
                startdatetime:'',
                ageFormatted:''
            },
            pendingChanges: false,
            isLetterTemplateValid: true,
            isPatientSignedDateValid: true,
            isEmployeeSignedDateValid: true,
            OffRoute: false,
            currentAppointmentDB:{
                guid:'',
                activitytypecode:'',
                employee:{
                firstname:"",
                    lastname:""
                }
            },
            AppointmentLettersRouteNames:[
                'patient-letter-add',
                'patient-letter-detail',
                'appointmentDB-letter-add',
                'appointmentDB-letter-detail'
            ],
            infoList:[],
            EmployeeList:[],
            LetterTemplateList: [],
            filters: [],
            editableItem: {
                therapistcode: '',
                templateCode: '',
                employeesigned: false,
                patientsigned: false,
                therapistsigneddate: null,
                patientsigneddate: null,
                patientCode: this.$route.params.id
            },
            letterTemplateModel: '',
            editableItemKey: null,
            letterContents: null,
            generated: false,
            isSignedByEmployee: false,
            isSignedByPatient: false
        }
    },

    computed: {
        generateButtonEnable() {
            return !Utils.isNullOrEmptyString(this.editableItem.templateCode);
        },

        saveButtonEnable() {
            return !this.isReadOnly && this.pendingChanges && this.generated;
        }
    },

    methods: {
        DiscardChanges() {       
            if(this.$route.name.includes('patient')){           
                this.$router.push({
                    name: "patient-letters",
                    params: { id: this.$route.params.id },
                });
            }
            else if(this.$route.name.includes('appointments-')){           
                this.$router.push({
                    name: "appointmentDB-letters",
                    params: { id: this.$route.params.id, actId: this.$route.params.actId },
                });
            }
            else{
                this.$router.push({
                    name: "Clinical-letters",
                    params: { id: this.$route.params.id, recordid:this.$route.params.recordid },
                });
            }       
        },

        generateLetter() {
            if(this.validate_required() && this.validateFilters()) {
                let parameters = this.filters.map(x => 
                    x.controlType == 'ctDate' ? Utils.formatterDate(x.controlValue) : 
                        x.controlType == 'ctCombo' ? (x.controlValue != null && x.controlValue != undefined ? x.controlValue.key : '') : 
                        x.controlValue
                );
                parameters.reverse();
                const data = {
                    ...this.editableItem, 
                    parameters: parameters,
                    patientCode: this.$route.params.id,
                    webQueryCode: true,
                    kindOfDocument: 'html',
                };

                NoteTemplatesService.generateLetter(data)
                    .then((response) => {
                        if(response.status == '200') {
                            this.letterContents = response.data.letterContent
                            this.generated = true;
                        }
                    })
                    .catch(error => {
                        this.showResponseErrorMessage(error);
                    });
            } else {
                this.showMessage(this.$tc('Msg.Error'),this.$t('Msg.CheckRedLabeledFields'),"errorAutoHide");
            }
        },

        async ClickOffRoute() {
            this.OffRoute = true;       
            await this.SaveOrEdit();
        },

        ClickSaveCall(){
            //this.ClickSave = true;
            this.SaveOrEdit();
        },

        async SaveOrEdit() {
            if(this.validate_required() && this.validateFilters()) {
                this.Mode ? await this.updateLetter() : await this.insertLetter();               
            } else {
                this.showMessage(this.$tc('Msg.Error'),this.$t('Msg.CheckRedLabeledFields'),"errorAutoHide");
            }
        },

        validate_required() {
            this.isLetterTemplateValid = !Utils.isNullOrEmptyString(this.editableItem.templateCode);
            this.isPatientSignedDateValid = this.isSignedByPatient && this.editableItem.patientsigned ? Utils.isValidDate(this.editableItem.patientsigneddate) : true;
            this.isEmployeeSignedDateValid = this.isSignedByEmployee && this.editableItem.employeesigned ? Utils.isValidDate(this.editableItem.therapistsigneddate) : true;
            return this.isLetterTemplateValid && this.isEmployeeSignedDateValid
                && this.isPatientSignedDateValid;
        },

        validateFilters() {
            let isValid = true;
            this.filters.forEach((param, index) => {
                if (param.controlType == 'ctDate') {
                    const refs = this.$refs['ctDate_' + index];
                    param.isValid = !Utils.isNullOrEmptyString(param.controlValue) && refs[0].editIsValid()
                }

                isValid &= param.isValid;
            });

            return isValid;
        },

        async updateLetter() {
            let parameters = this.filters.map(x => 
                x.controlType == 'ctDate' ? Utils.formatterDate(x.controlValue) : 
                    x.controlType == 'ctCombo' ? (x.controlValue != null && x.controlValue != undefined ? x.controlValue.key : '') : 
                    x.controlValue
            );
            parameters.reverse();
            const data = {
                ...this.editableItem, 
                parameters: parameters, 
                letterContents: this.letterContents
            };

            await NoteTemplatesService
                .update(this.editableItemKey.headerId, this.editableItemKey.templateCode, this.editableItemKey.recId, data)
                .then((response) => {
                    if(response.status == '200') {
                        this.showMessage(this.$t('Msg.Success'), this.$t('Msg.SavedSuccessfully'), "success");
                        this.pendingChanges = false;

                        if(!this.OffRoute) {
                            this.DiscardChanges();
                        }
                    }
                })
                .catch(error => {
                    this.showResponseErrorMessage(error);
                });
        },

        async insertLetter(){
            const data = {
                ...this.editableItem,
                letterContents: this.letterContents
            };

            await NoteTemplatesService
                .add(data)
                .then((response) => {
                    if(response.status == '200') {
                        this.pendingChanges = false;
                        this.showMessage(this.$t('Msg.Success'), this.$t('Msg.SavedSuccessfully'), "success");

                        if(!this.OffRoute) {
                            this.DiscardChanges();
                        }
                    }
                })
                .catch(error => {
                    this.showResponseErrorMessage(error);
                });
        },

        changeDropDownLetterTemplate(value) {
            this.editableItem.templateCode = value?.code ?? '';
            this.letterTemplateModel = value?.code ?? '';
            this.isSignedByEmployee = value?.isSignedByEmployee ?? false;
            this.isSignedByPatient = value?.isSignedByPatient ?? false;
            this.generated = false;
            this.pendingChanges = this.generated;

            if (!Utils.isNullOrEmptyString(this.editableItem.templateCode)) {
                this.$nextTick(() => this.getLetterTemplateInfo(this.editableItem.templateCode));
            } else {
                this.letterContents = null;
            }
        },

        onChangePatientSigned(value) {
            if (value === true) {
                this.editableItem.patientsigneddate = Utils.formatterDate(new Date());
            } else {
                this.editableItem.patientsigneddate = null;
            }
        },

        onChangeEmployeeSigned(value) {
            if (value === true) {
                this.editableItem.therapistsigneddate = Utils.formatterDate(new Date());
            } else {
                this.editableItem.therapistsigneddate = null;
            }
        },

        changeDropDown(e, filter) {
            filter.controlValue = e;
        },

        onDatePressEnter() {

        },

        async getLetterTemplateInfo(code) {
            const data = {
                templateCode: code,
                KindOfDocument: 'html',
                webQueryCode: true,
                patientCode: this.$route.params.id
            }
            await NoteTemplatesService.getLetterTemplateInfo(data)
                .then((response) => {
                    if (response.status == '200' && response.data) {
                        this.filters = [];
                        const customExportsItem = response.data;
                        customExportsItem.parameters.forEach((param) => {
                            param.isValid = true;
                            if (param.controlType == 'ctDate' && Utils.isNullOrEmptyString(param.controlValue)) {
                                param.controlValue = Utils.formatterNowToDate();
                            } else if (param.controlType == 'ctCombo') {
                                param.controlValue = param.itemList.find(x => x.Key == param.controlValue)
                            } 
                            this.filters.push({...param});
                        });

                        this.filters.reverse();
                    } else {
                        this.filters = [];
                    }
                })
                .catch((error) => {
                    this.showResponseErrorMessage(error);
                }
            )
        },

        getLetterTemplate() {
            const data = {
                headerId: this.editableItemKey.headerId, 
                templateCode: this.editableItemKey.templateCode, 
                id: this.editableItemKey.recId,
                patientCode: this.$route.params.id
            }
            NoteTemplatesService
                .get(data)
                .then((response) => {
                    if(response.status == '200') {
                        this.editableItem = response.data;
                        this.editableItem.templateCode = this.editableItemKey.templateCode;
                        this.editableItem.patientCode = this.$route.params.id;
                        
                        this.filters = [];
                        this.editableItem.parameters.forEach((param) => {
                            param.isValid = true;
                            if (param.controlType == 'ctDate' && Utils.isNullOrEmptyString(param.controlValue)) {
                                param.controlValue = Utils.formatterNowToDate();
                            } else if (param.controlType == 'ctCombo') {
                                param.controlValue = param.itemList.find(x => x.Key == param.controlValue)
                            } 
                            this.filters.push({...param});
                        });
                        
                        this.filters.reverse();
                        this.letterContents = this.editableItem.letterContents;
                        delete this.editableItem.letterContents;
                        delete this.editableItem.parameters;

                        this.generated = true;
                    }

                    setTimeout(() => {
                        this.pendingChanges = false;
                    }, 100);
                })
                .catch(error => {
                    this.showResponseErrorMessage(error);
                });
        },

        async GetPatientByCode(){
            this.infoList = await this.getInfoTitle(this.$route.params.id);
            if(this.infoList.length > 0){
                this.PatientTitle.programName = '';
                this.PatientTitle.admitDate = '';
                this.PatientTitle.dischargeDate = '';
            
                const { dob, firstname, lastname, age, ageFormatted } = this.infoList[0]; // Destructure for easier access

                if (ageFormatted) this.PatientTitle.ageFormatted = ageFormatted;
                if (dob) this.PatientTitle.dob = Utils.formatterDateToString(dob);
                if (age) this.PatientTitle.age = age;
                if (firstname) this.PatientTitle.fullName = firstname + ' '+ lastname; 
                this.patient = this.infoList[0];           
            }
        },

        PopulatePatientTitle(){
            const { dob, dateFrom, dateTo, age, 
                programName, patientName, ageFormatted } = this.RegistrationInfo; // Destructure for easier access
        
            if (dateFrom) this.RegistrationInfo.dateFrom = Utils.formatterDateToString(dateFrom);
            if (dateTo) this.RegistrationInfo.dateTo = Utils.formatterDateToString(dateTo);	

            if(this.$route.name.includes('Clinical')){ 
                if (programName) this.PatientTitle.programName = programName; 
                if (dateFrom) this.PatientTitle.dateFrom = this.RegistrationInfo.dateFrom;
                if (dateTo) this.PatientTitle.dateTo = this.RegistrationInfo.dateTo;
                if (patientName) this.PatientTitle.fullName = patientName;
                if (dob) this.PatientTitle.dob = dob;
                if (age) this.PatientTitle.age = age === 0 ? "0" : age;
                if (ageFormatted) this.PatientTitle.ageFormatted = this.RegistrationInfo.ageFormatted;
            }

            if(this.AppointmentLettersRouteNames.some(route => this.$route.name.includes(route))){         
                this.PatientTitle.programName = '';
                this.PatientTitle.dateFrom = '';
                this.PatientTitle.dateTo = '';

                if(this.infoList.length > 0){
                    const { dob, firstname, lastname } = this.infoList[0]; // Destructure for easier access
                
                    if (dob) this.PatientTitle.dob = Utils.formatterDateToString(dob);
                    if (firstname) this.PatientTitle.fullName = firstname + ' '+ lastname;            
                }          
            }
        },

        async getCurrentAppointment() {
            this.currentAppointmentDB = await this.geCurrentAppointment(this.$route.params.actId);
            this.PatientTitle.activitytypename  = this.currentAppointmentDB.activitytypename
            this.PatientTitle.startdatetime = `${Utils.formatterDateToString(this.currentAppointmentDB.transdate)} ${this.currentAppointmentDB.timein}`  
        },

        async getAllEmployee(){
            await GlobalService.getEmployeeActive()
                .then((response) => {
                    if(response.status == '200'){
                        this.EmployeeList = response.data.map(x => {return {code: x.code, name: x.name} })
                    }                             
                })
                .catch((error) => {
                    this.showResponseErrorMessage(error);
                });
        },

        async getAllLetterTemplate(){
            const parameters = {
                kindOfTemplate: 'T',
                KindOfDocument: 'html'
            }
            await LetterTemplatesService.getLookUp(parameters)
                    .then((response) => { 
                        if(response.data && response.data.length > 0){
                            var arr = response.data;
                            this.LetterTemplateList = arr.map(x => {
                                return {
                                    code: x.code, 
                                    name: x.description,
                                    isSignedByPatient: x.isSignedByPatient,
                                    isSignedByEmployee: x.isSignedByEmployee
                                } 
                            })
                        }             
                    })
                    .catch((error) => {
                        this.showResponseErrorMessage(error);
                    });
        },
    },

    created () {
        EventBus.$on("onChanged", function (e) {          
            this.pendingChanges |= e.Changed
        }.bind(this));
    },

    async mounted(){
        this.OptionsRightMenu.ItemsList = this.$route.name.includes('Clinical') 
            ? EnumService.ClinicalItems : this.$route.name.includes('appointments-') 
            ? EnumService.AppointmentItems : EnumService.PatientItems;
        this.OptionsRightMenu.visible = true;
        this.$emit("getVisibleMenu", this.OptionsRightMenu);

        this.OptionsRightMenu.Mode = this.Mode;       
        if(this.AppointmentLettersRouteNames.some(route => this.$route.name.includes(route))){  
            this.GetPatientByCode();
        }

        if(this.$route.name.includes('Clinical')){      
            this.RegistrationInfo = await this.getRegistrationInfoTitle(this.$route.params.recordid);
            const { dateTo, age, dob } = this.RegistrationInfo; // Destructure for easier access

            this.IsClinical = dateTo ? false : true;
            if (age) this.RegistrationInfo.age = age === 0 ? "0" : age;
            if (dob) this.RegistrationInfo.dob =  Utils.formatterDateToString(dob);
        }

        this.PopulatePatientTitle();
        await this.getAllEmployee();
        await this.getAllLetterTemplate();

        if (this.$route.name.includes('appointmentDB-'))
            await this.getCurrentAppointment()

        if (this.Mode) {
            const stored = sessionStorage.getItem('PatientLetterRecord');

            if (stored) {
                this.editableItemKey = JSON.parse(stored);

                if (this.editableItemKey) {
                    this.letterTemplateModel = this.editableItemKey.templateCode;
                    await this.getLetterTemplate();
                }
            }
        }
    },

    destroyed() {
        sessionStorage.removeItem('PatientLetterRecord');
    },

    beforeRouteLeave(to, from, next) {
        if (!this.isReadOnly && this.pendingChanges) {
            this.$bvModal.msgBoxConfirm(this.$t('Msg.LeavingWithoutSaving'), {
                            title: this.$t('Msg.Confirm'),
                            okTitle: this.$t('Shared.BtnSave'),
                            cancelTitle: this.$t('Shared.BtnDismiss'),
                            footerClass: 'p-2',
                            titleClass: 'modal-title modal-type-warning'
                        })
                        .then(async value => {
                            if(!value){
                                next();
                            } else {
                                await this.ClickOffRoute();
                                var f = this.WasSaved;             
                                if(f){
                                    next();
                                }
                            }
                        })		
        } else {
            next()
        }
    },
}
</script>